<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="用户类型：" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择" style="width: 424px;">
              <el-option
                v-for="item in memberLeveTypeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="等级名称：" prop="name">
            <el-input style="width: 424px;" v-model="ruleForm.name" placeholder="请输入等级名称"></el-input>
          </el-form-item>
          <el-form-item label="图片：" prop="imgUrl">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="fileList"
              :on-remove="delImgBtn"
              :on-success="bannerImgBtn">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="享受折扣：" prop="discountRate">
            <el-input style="width: 424px;" v-model="ruleForm.discountRate" placeholder="请输入折扣，95折输入0.95"></el-input>
          </el-form-item>
          <el-form-item label="升级条件：" prop="minMoney">
            <el-col :span="6">
              <el-input style="width: 100%;" v-model="ruleForm.minMoney" placeholder="最低消费金额"></el-input>
            </el-col>
            <el-col class="flex-justify-center" :span="1">-</el-col>
            <el-col :span="6">
              <el-input style="width: 100%;" v-model="ruleForm.meetMoney" placeholder="不高于消费金额"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="充值赠送比例：" prop="giftProportion">
            <el-input style="width: 424px;" v-model="ruleForm.giftProportion" placeholder="请输入比例,单位%"></el-input>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveUserMemberLevel, updateUserMemberLevel, fetchUserMemberLevelDetailById } from '@/api/level'
export default {
  name: 'LevelAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token: this.$token,
      memberLeveTypeArr: [{
        value: 1,
        label: '会员'
      }, {
        value: 2,
        label: '内部员工'
      }, {
        value: 3,
        label: '合伙人'
      }],
      dataId: this.$route.query.dataId,
      fileList: [],
      ruleForm: {
        name: '',
        imgUrl: '',
        type: '',
        minMoney: '',
        meetMoney: '',
        discountRate: '',
        giftProportion:'',
        sort: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入等级名称', trigger: 'blur' }
        ],
        imgUrl: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择等级类型', trigger: 'blur' }
        ],
        minMoney: [
          { required: true, message: '请输入升级条件', trigger: 'blur' }
        ],
        discountRate: [
          { required: true, message: '请输入折扣', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    if (this.$route.query.dataId === undefined || this.$route.query.dataId === 'undefined') {
      this.dataId = ''
    } else {
      let that = this
      fetchUserMemberLevelDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.name = data.name
          that.ruleForm.sort = data.sort
          that.ruleForm.imgUrl = data.imgUrl
          that.fileList.push({url: data.imgUrl})
          that.ruleForm.type = data.type
          that.ruleForm.discountRate = data.discountRate
          that.ruleForm.minMoney = data.minMoney
          that.ruleForm.meetMoney = data.meetMoney
          that.ruleForm.giftProportion = data.giftProportion
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    bannerImgBtn (file) {
      this.ruleForm.imgUrl = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var imgUrl = '';
      fileList.forEach(function(item){
        imgUrl = item.url;
      });
      this.ruleForm.imgUrl = imgUrl;
    },
    // 保存操作
    saveBtn () {
      var that = this
      let dataId = that.dataId
      let type = that.ruleForm.type
      let name = that.ruleForm.name
      let imgUrl = that.ruleForm.imgUrl
      let discountRate = that.ruleForm.discountRate
      let minMoney = that.ruleForm.minMoney
      var meetMoney = that.ruleForm.meetMoney
      var giftProportion = that.ruleForm.giftProportion
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      console.log(type, 'type')
      if (type === '') {
        this.$message.error('请选择用户类型')
        return false
      }
      if (name === '') {
        this.$message.error('请输入等级名称')
        return false
      }
      if (imgUrl === '') {
        this.$message.error('请上传图片')
        return false
      }
      if (discountRate === '') {
        this.$message.error('请输入折扣')
        return false
      }
      if (minMoney === '') {
        this.$message.error('请输入最低消费金额')
        return false
      }
      if (meetMoney === '') {
        this.$message.error('请输入不高于消费金额')
        return false
      }
      let passData = {
        type: type, name: name, imgUrl: imgUrl, discountRate: discountRate, minMoney: minMoney, meetMoney: meetMoney, giftProportion: giftProportion, sort: sort
      }
      if (dataId !== '') {
        passData = {
          id: dataId, type: type, name: name, imgUrl: imgUrl, discountRate: discountRate, minMoney: minMoney, meetMoney: meetMoney, giftProportion: giftProportion, sort: sort
        }
        updateUserMemberLevel(passData).then((res) => {
        if (res.errorCode === '0000') {
          that.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(-1)
            }
          })
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg)
        }
      })
      }else{
        // console.log(passData, 'passData')
        saveUserMemberLevel(passData).then((res) => {
          if (res.errorCode === '0000') {
            that.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.$router.go(-1)
              }
            })
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg)
          }
        })
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/Add.vue